module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_orange_03-eb1952804eb27c584e63fb4bc059e568.svg";